import { Component } from '@angular/core';
import { DataService } from '../../Services/data.service';
import { DialogService } from '../../Services/dialog.service';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { BarChartComponent } from '../bar-chart/bar-chart.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-dash-board',
  standalone: true,
  imports: [CommonModule, BarChartComponent,MatProgressSpinner],
  templateUrl: './dash-board.component.html',
  styleUrl: './dash-board.component.css'
})
export class DashBoardComponent {

  dashBoardDataComplete: any;
  dashBoardDataInComplete: any;
  dashBoardDataDelivered: any;
  role: any;
  dashboardReady = false;

  constructor(public dataService: DataService, private dialogService: DialogService, private router: Router) { }

  ngOnInit(): void {
  this.dashboardReady = false;
  this.dataService.updateProgressBarSubject(true);

  this.role = this.dataService.role;
  this.dataService.updateTitle("Dashboard");

  const params = {
    startDate: '2024-01-01',
    endDate: new Date().toISOString().split('T')[0],
  };

  const requests: any = {
    inProgress: this.dataService.getDataDas('/tasks/in-progress', params),
    completed: this.dataService.getDataDas('/tasks/complete', params)
  };

  if (this.role === 'doctor') {
    requests.delivered = this.dataService.getDataDas('/tasks/delivered', params);
  }

  if (this.role !== 'doctor') {
    requests.amount = this.dataService.getDataDas('/tasks/amount', params);
  }

  forkJoin(requests).subscribe({
    next: (res: any) => {

      this.dashBoardDataInComplete = res.inProgress?.length || 0;
      this.dashBoardDataComplete = res.completed?.length || 0;

      if (res.delivered) {
        this.dashBoardDataDelivered = res.delivered.length;
      }

      // you can store amount if needed
      if (res.amount) {
      }
    },
    error: (err) => {
      this.dialogService.handleError(err, 'Failed to load dashboard data.');
    },
    complete: () => {
      this.dataService.updateProgressBarSubject(false);  // ✅ hide loader
      this.dashboardReady = true;                         // ✅ show UI
    }
  });
}

  getDelivered() {
    const params = {
      startDate: '2024-01-01',
      endDate:  new Date().toISOString().split('T')[0],
    };
    this.dataService.getDataDas('/tasks/delivered', params).subscribe({
      next: (response) => {
      
        this.dashBoardDataDelivered = response.length;
      },
      error: (err) => {
        this.dialogService.handleError(err, 'Failed to get In Progress Tasks, Please try again.');
      }
    });
  }


  getAmmount() {
    const params = {
      startDate: '2024-01-01',
      endDate:  new Date().toISOString().split('T')[0],
    };
    this.dataService.getDataDas('/tasks/amount', params).subscribe({
      next: (response) => {
      },
      error: (err) => {
        this.dialogService.handleError(err, 'Failed to get In Progress Tasks, Please try again.');
      }
    });
  }

  getInProgressTasks() {
    const params = {
      startDate: '2024-01-01',
      endDate:  new Date().toISOString().split('T')[0],
    };
    this.dataService.getDataDas('/tasks/in-progress', params).subscribe({
      next: (response) => {

        this.dashBoardDataInComplete = response.length;
      },
      error: (err) => {
        this.dialogService.handleError(err, 'Failed to get In Progress Tasks, Please try again.');
      }
    });
  }


getInProgressTasksPromise(): Promise<void> {
  return new Promise((resolve, reject) => {
    const params = {
      startDate: '2024-01-01',
      endDate: new Date().toISOString().split('T')[0],
    };

    this.dataService.getDataDas('/tasks/in-progress', params).subscribe({
      next: (response) => {
        this.dashBoardDataInComplete = response.length;
        resolve();
      },
      error: (err) => reject(err)
    });
  });
}

getCompletedTasksPromise(): Promise<void> {
  return new Promise((resolve, reject) => {
    const params = {
      startDate: '2024-01-01',
      endDate: new Date().toISOString().split('T')[0],
    };

    this.dataService.getDataDas('/tasks/complete', params).subscribe({
      next: (response) => {
        this.dashBoardDataComplete = response.length;
        resolve();
      },
      error: (err) => reject(err)
    });
  });
}


  getCompletedTasks() {
    const params = {
      startDate: '2024-01-01',
      endDate:  new Date().toISOString().split('T')[0],

    };
    this.dataService.getDataDas('/tasks/complete', params).subscribe({
      next: (response) => {
        this.dashBoardDataComplete = response.length;
      },
      error: (err) => {
        this.dialogService.handleError(err, 'Failed to get In Progress Tasks, Please try again.');
      }
    });
  }

openAllTasks() {
  this.router.navigate(['/task-list', 'all-tasks']).then(() => {
    this.dataService.trigger('');   // 🔥 now TaskList WILL receive it
  });
}

openInProgressTasks() {
  this.router.navigate(['/task-list', 'all-tasks']).then(() => {
    this.dataService.trigger('IP');   // 🔥 now TaskList WILL receive it
  });
}

openCompletedTasks() {
  this.router.navigate(['/task-list', 'all-tasks']).then(() => {
    this.dataService.trigger('CO');   // 🔥 now TaskList WILL receive it
  });
}

openDeliveredTasks() {
  this.router.navigate(['/task-list', 'all-tasks']).then(() => {
    this.dataService.trigger('PF');   // 🔥 now TaskList WILL receive it
  });
}

}